import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-guias-clientes',
  templateUrl: './guias-clientes.component.html',
  styleUrls: ['./guias-clientes.component.css']
})
export class GuiasClientesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
